import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import { Alert } from '@bingads-webui-react/alert';
import { bannerStyles } from './css/new-styles';
import { helpTopicId } from './consts';

export const CouponBannerNew = injectSheet(bannerStyles)(({
  classes,
  coupon,
  i18n,
  titleKey,
  messageKey,
}) => {
  const title = i18n.getString(titleKey);
  const link = (
    <button
      className={classNames(
        'notification-center-top-banner-action',
        'HelpTopic',
        classes.actionButtonStyle
      )}
      query={helpTopicId}
    >
      {i18n.getString('Coupon_TermsAndConditions')}
    </button>
  );

  const bannerMessage = i18n.getString(messageKey, coupon);

  return (
    <div className={classNames(classes.topBanner, 'coupon-top-banner')}>
      <Alert
        icon={<span className={classes.couponIcon} />}
        message={
          <React.Fragment>
            <b>{title}</b> {bannerMessage}
          </React.Fragment>
        }
        dismissible={false}
        customCssClass={classNames('coupon-banner', 'alert-coupon')}
      /> {link}
    </div>
  );
});

CouponBannerNew.propTypes = {
  coupon: PropTypes.shape({
    value: PropTypes.string.isRequired,
    cost: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  titleKey: PropTypes.string,
  messageKey: PropTypes.string,
};

CouponBannerNew.defaultProps = {
  titleKey: 'FAC_Coupon_Banner_Title',
  messageKey: 'FAC_Coupon_Banner',
};
